import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 7,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
    md: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 7,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
    xs: [
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 7,
            static: true,
            w: 24,
            x: 0,
            y: 3,
            i: 'c2',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        analysis_type: {
            label: 'template-based',
            value: 'template-based',
            path: '/portfolio/performance/create-strategy/template-based',
            ga_event_name: 'Performance > View strategies > Template Based',
        },
        analysis_types: [
            {
                label: 'individual-strategy-creation',
                options: [
                    {
                        label: 'rule-based',
                        value: 'rule-based',
                        path: '/portfolio/performance/create-strategy/rule-based',
                        ga_event_name:
                            'Performance > View strategies > Rule Based',
                    },
                    {
                        label: 'query-based',
                        value: 'query-based',
                        path: '/portfolio/performance/create-strategy/query-based',
                        ga_event_name:
                            'Performance > View strategies > Query Based',
                    },
                ],
            },
            {
                label: 'bulk-strategy-creation',
                options: [
                    {
                        label: 'template-based',
                        value: 'template-based',
                        path: '/portfolio/performance/create-strategy/template-based',
                        ga_event_name:
                            'Performance > View strategies > Template Based',
                    },
                ],
            },
        ],
    },
    components: [
        {
            key: 'c1',
            name: 'page-header',
            props: {
                header: {
                    title: 'performance',
                    path: '/portfolio/performance',
                },
                subHeader: [
                    {
                        title: 'manage-strategies',
                        path: '/portfolio/performance/view-strategies',
                        ga_event_name: 'Performance > View strategies',
                    },
                    {
                        title: 'create-strategies',
                        path: '/portfolio/performance/create-strategy/rule-based',
                        ga_event_name:
                            'Performance > View strategies > Rule Based',
                    },
                    {
                        title: 'template-based',
                        path: '',
                    },
                ],
                rhsComponents: [
                    {
                        name: 'create-strategies',
                        props: {
                            width: '170px',
                            maxMenuHeight: 200,
                        },
                    },
                ],
                pageSupportLink: 'REACT_APP_TEMPLATE_BASED_LINK',
            },
        },
        {
            name: 'template-based-strategy',
            key: 'c2',
            props: {},
        },
    ],
};
